import { useState, useEffect, useRef } from "react";

const DEBOUNCE_MS = 150;

interface UseVisitorSearchResult {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  debouncedSearchQuery: string;
  searchInputRef: React.RefObject<HTMLInputElement>;
  clearSearch: () => void;
}

/**
 * Manages search state with debouncing for visitor map
 */
export function useVisitorSearch(initialQuery = ""): UseVisitorSearchResult {
  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(initialQuery);
  const searchInputRef = useRef<HTMLInputElement>(null);

  // Debounce search query
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const clearSearch = () => {
    setSearchQuery("");
    setDebouncedSearchQuery("");
  };

  return {
    searchQuery,
    setSearchQuery,
    debouncedSearchQuery,
    searchInputRef,
    clearSearch,
  };
}
